module.exports = __webpack_public_path__ + "img/ski_sub_title6.80d0b5b8.jpg";